// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".score[data-v-58b0f2d5]{height:100%}.score .left[data-v-58b0f2d5]{float:left}.score .right[data-v-58b0f2d5]{float:right}.score .table_div[data-v-58b0f2d5]{height:calc(100% - .34722rem);padding:.13889rem 0}", ""]);
// Exports
module.exports = exports;
